import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import "./App.css";

// Pages
import Login from "./pages/Login";
import AdminDashboard from "./pages/AdminDashboard";
import TeacherDashboard from "./pages/TeacherDashboard";
import Teachers from "./pages/Teachers";
import Books from "./pages/Books";
import ManageBooks from "./pages/ManageBooks";
import Reports from "./pages/Reports";
import Settings from "./pages/Settings";
import JauhariAI from "./pages/JauhariAI";
import AdminElibrary from "./pages/AdminElibrary";


// Protected Route Component
const ProtectedRoute = ({ children, requiredRole }) => {
  const isAuthenticated = localStorage.getItem("isAuthenticated") === "true";
  const userRole = localStorage.getItem("role");
  
  if (!isAuthenticated) {
    return <Navigate to="/" replace />;
  }
  
  if (requiredRole && userRole !== requiredRole) {
    // Redirect to appropriate dashboard based on role
    if (userRole === "admin") {
      return <Navigate to="/admin-dashboard" replace />;
    } else if (userRole === "teacher") {
      return <Navigate to="/teacher-dashboard" replace />;
    }
    return <Navigate to="/" replace />;
  }
  
  return children;
};

// Public Route - redirects to dashboard if already logged in
const PublicRoute = ({ children }) => {
  const isAuthenticated = localStorage.getItem("isAuthenticated") === "true";
  const userRole = localStorage.getItem("role");
  
  if (isAuthenticated) {
    if (userRole === "admin") {
      return <Navigate to="/admin-dashboard" replace />;
    } else if (userRole === "teacher") {
      return <Navigate to="/teacher-dashboard" replace />;
    }
  }
  
  return children;
};

function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* LOGIN - Public Route */}
        <Route 
          path="/" 
          element={
            <PublicRoute>
              <Login />
            </PublicRoute>
          } 
        />
        <Route 
          path="/login" 
          element={
            <PublicRoute>
              <Login />
            </PublicRoute>
          } 
        />

        {/* ADMIN DASHBOARD */}
        <Route 
          path="/admin-dashboard" 
          element={
            <ProtectedRoute requiredRole="admin">
              <AdminDashboard />
            </ProtectedRoute>
          } 
        />
        
        {/* TEACHER DASHBOARD */}
        <Route 
          path="/teacher-dashboard" 
          element={
            <ProtectedRoute requiredRole="teacher">
              <TeacherDashboard />
            </ProtectedRoute>
          } 
        />

        {/* ADMIN PAGES */}
        <Route 
          path="/teachers" 
          element={
            <ProtectedRoute requiredRole="admin">
              <Teachers />
            </ProtectedRoute>
          } 
        />
        
        <Route 
          path="/books" 
          element={
            <ProtectedRoute requiredRole="admin">
              <Books />
            </ProtectedRoute>
          } 
        />
        
        <Route 
          path="/manage-books" 
          element={
            <ProtectedRoute requiredRole="admin">
              <ManageBooks />
            </ProtectedRoute>
          } 
        />
        <Route 
  path="/admin-elibrary" 
  element={
    <ProtectedRoute requiredRole="admin">
      <AdminElibrary />
    </ProtectedRoute>
  } 
/>
        
        <Route 
          path="/reports" 
          element={
            <ProtectedRoute requiredRole="admin">
              <Reports />
            </ProtectedRoute>
          } 
        />

        {/* SETTINGS PAGE */}
        <Route 
          path="/settings" 
          element={
            <ProtectedRoute requiredRole="admin">
              <Settings />
            </ProtectedRoute>
          } 
        />


    

        {/* JAUHARI AI PAGE - Accessible by both Admin and Teacher */}
        <Route 
          path="/jauhari-ai" 
          element={
            <ProtectedRoute>
              <JauhariAI />
            </ProtectedRoute>
          } 
        />

        {/* ISSUE/RETURN ROUTES (same as manage-books) */}
        <Route 
          path="/issue" 
          element={
            <ProtectedRoute requiredRole="admin">
              <ManageBooks />
            </ProtectedRoute>
          } 
        />
        
        <Route 
          path="/return" 
          element={
            <ProtectedRoute requiredRole="admin">
              <ManageBooks />
            </ProtectedRoute>
          } 
        />

        {/* FALLBACK - 404 Page */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;